import apolloClient from '@/libs/apollo'
import { minhasUnidades, unidades } from '@/libs/apollo/queries/unidade'

export default {
  async fetchMinhasUnidades({ commit }) {
    commit('SET_LOADING', true)
    const response = await apolloClient.query({
      query: minhasUnidades,
    })
    commit('SET_LOADING', false)
    commit('SET_MINHAS_UNIDADES', response.data.minhasUnidades)
  },
  fetchUnidades({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      apolloClient.query({
        query: unidades,
        variables: { offset: params.page },
      }).then(res => {
        commit('ADD_TODAS_UNIDADES', res.data.unidades)
        resolve(res)
      }).catch(err => {
        reject(err)
      }).finally(() => {
        commit('SET_LOADING', false)
      })
    })
  },
}
